import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { toast } from 'sonner';
import { api } from '../lib/api';

export default function Profile() {
  const { user, updateSession } = useAuth();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(user.email);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleEmailUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.updateProfile({ email });
      
      // Aktualisiere die Session mit der neuen E-Mail
      const updatedUser = { ...user, email };
      updateSession(updatedUser);
      
      toast.success('E-Mail-Adresse wurde aktualisiert');
    } catch (error) {
      console.error('Fehler beim Aktualisieren der E-Mail:', error);
      toast.error('E-Mail konnte nicht aktualisiert werden');
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      toast.error('Die Passwörter stimmen nicht überein');
      return;
    }

    setLoading(true);

    try {
      const response = await api.updatePassword({
        currentPassword,
        newPassword
      });
      
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      toast.success('Passwort wurde aktualisiert');
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Passworts:', error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Profil</h1>
      
      <div className="grid gap-6 max-w-xl">
        <Card>
          <CardHeader>
            <CardTitle>E-Mail ändern</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleEmailUpdate} className="space-y-4">
              <div className="space-y-2">
                <Input
                  type="email"
                  placeholder="Neue E-Mail-Adresse"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <Button
                type="submit"
                disabled={loading || email === user.email}
              >
                E-Mail aktualisieren
              </Button>
            </form>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Passwort ändern</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handlePasswordUpdate} className="space-y-4">
              <div className="space-y-2">
                <Input
                  type="password"
                  placeholder="Aktuelles Passwort"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  required
                />
              </div>
              <div className="space-y-2">
                <Input
                  type="password"
                  placeholder="Neues Passwort"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>
              <div className="space-y-2">
                <Input
                  type="password"
                  placeholder="Neues Passwort bestätigen"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
              <Button
                type="submit"
                disabled={loading || !currentPassword || !newPassword || !confirmPassword}
              >
                Passwort aktualisieren
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
} 